import axios from 'axios';
import queryString from 'query-string';
import { getAPI } from 'utils/helpers';

export const getReservationsByUserId = ({ primaryUserId, pageParam, size, statuses }) => {
  return axios
    .get(
      queryString.stringifyUrl(
        {
          url: `${getAPI()}/primary_facade/v2/users/${primaryUserId}/reservations`,
          query: {
            page: pageParam,
            size,
            statuses,
          },
        },
        {
          skipEmptyString: true,
        },
      ),
    )
    .then(({ data }) => data);
};
